import useHistoryTableFilterStore from 'src/stores/historyTableFilterStore/useHistoryTableFilterStore';
import PortfolioHistoryTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTableControls';
import PortfolioHistoryTableMarketFilter from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTableMarketFilter';

export default function PortfolioHistoryRewardsTableControls() {
	const marketFilter = useHistoryTableFilterStore(
		(s) => s.getFilterState('rewards')['spotMarketSymbol']
	);
	const setHistoryTableFilterState = useHistoryTableFilterStore((s) => s.set);

	const handleMarketFilterChange = (selectedMarket: string) => {
		setHistoryTableFilterState((s) => {
			s['rewards'].spotMarketSymbol = selectedMarket;
			s['rewards'].currentUiPage = 0;
		});
	};

	return (
		<PortfolioHistoryTableControls historyType="rewards" exportType="rewards">
			<PortfolioHistoryTableMarketFilter
				marketType="spot"
				marketFilter={marketFilter}
				handleMarketFilterChange={handleMarketFilterChange}
				id="portfolio-history-rewards-table-market-filter"
			/>
		</PortfolioHistoryTableControls>
	);
}
